import { ButtonRoundedSm } from '@apps-common/components/elements'
import { ModalBody, ModalCloseButton, ModalContainer, ModalHeader, ModalHeaderContainer } from '@apps-common/components/modals/modal'
import { commonIcons } from '@apps-common/config/icons'
import { ModalDismiss } from '@apps-common/config/modal'

export enum UnitTaskModalOption {
  MonitoringChange = 'monitoring_change',
  ServerChange = 'server_change',
  ServerBalance = 'server_balance',
  ViewDeviceTasks = 'view-device-tasks'
}

export const UnitTaskOptionsModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: any
}) => {
  return (
    <ModalContainer innerClasses='!min-h-0 h-auto !max-w-[340px]'>
      <ModalHeaderContainer classes='pb-0'>
        <div className='flex items-center justify-between'>
          <ModalHeader subtitle='Tasks' />
          <ModalCloseButton closeModal={() => onDismiss(null, ModalDismiss.Cancel)} />
        </div>
      </ModalHeaderContainer>

      <ModalBody classes='!pt-[80px] !pb-[40px]'>
        <div className='flex flex-col gap-[20px]'>
          <div className='mb-[10px]'>
            <div className='bg-info/30 text-text ring-1 ring-info text-[0.9rem] rounded-3xl px-[20px] py-[15px]'>
              The filtered devices will be used if <b>monitoring change</b> or <b>server change</b> is selected.
            </div>
          </div>
          <ButtonRoundedSm
            type='button'
            loading={false}
            text='Monitoring Change'
            icon={<commonIcons.srMcChanges className='text-[1rem]' />}
            iconRight
            className='w-full action-brand'
            callback={() => onDismiss(UnitTaskModalOption.MonitoringChange, ModalDismiss.Confirm)}
          />
          <ButtonRoundedSm
            type='button'
            loading={false}
            text='Server Change'
            icon={<commonIcons.srServerChange className='text-[1.1rem]' />}
            iconRight
            className='w-full action-brand'
            callback={() => onDismiss(UnitTaskModalOption.ServerChange, ModalDismiss.Confirm)}
          />
          <ButtonRoundedSm
            type='button'
            loading={false}
            text='Server Balance'
            icon={<commonIcons.srServerBalance className='text-[1.1rem]' />}
            iconRight
            className='w-full action-brand'
            callback={() => onDismiss(UnitTaskModalOption.ServerBalance, ModalDismiss.Confirm)}
          />
          <div className='border-b border-border' />
          <ButtonRoundedSm
            type='button'
            loading={false}
            text='View Tasks'
            icon={<commonIcons.arrowAngled className='text-[1.1rem]' />}
            iconRight
            className='w-full action-success'
            callback={() => onDismiss(UnitTaskModalOption.ViewDeviceTasks, ModalDismiss.Confirm)}
          />
        </div>
      </ModalBody>
    </ModalContainer>
  )
}
